import { useNextgenRouter } from '@nextgen-web-framework/all';
import { useEffect, useRef, useState } from 'react';
import { PageLoader } from '@commerce-webcomponents/ui';
import { LoaderProps } from './types/propsTypes';

const isModifierKeyPressed = (e: MouseEvent): boolean => {
  if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) {
    return true;
  }
  return false;
};

const isExternalOrHash = (url: string): string | boolean => {
  const isExternal = /^(https?:\/\/.*|.*\.xml)$/.test(url);
  const hasHash = url === window.location.pathname && window.location.hash;
  return isExternal || hasHash;
};

const Loader = (props: LoaderProps) => {
  const router = useNextgenRouter();
  const shouldStartLoadingRef = useRef<boolean>(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let startTimer: NodeJS.Timeout;
    const handleStart = (url: string) => {
      // Start loader ONLY when navigating to a relative url, non xml paths and non hash route and if it is not trying to open a page in new window or tab
      if (!shouldStartLoadingRef.current || isExternalOrHash(url)) {
        return;
      }
      clearTimeout(startTimer);
      startTimer = setTimeout(() => {
        setLoading(true);
      }, 200);
    };
    const handleComplete = () => {
      clearTimeout(startTimer);
      setLoading(false);
      shouldStartLoadingRef.current = false;
    };

    const handleGlobalClick = (e: MouseEvent) => {
      if (e.button === 0 && isModifierKeyPressed(e)) {
        shouldStartLoadingRef.current = false;
        return;
      }
      shouldStartLoadingRef.current = true;
    };
    router.events?.on('routeChangeStart', handleStart);
    router.events?.on('routeChangeComplete', handleComplete);
    router.events?.on('routeChangeError', handleComplete);

    document.addEventListener('click', handleGlobalClick, true);

    return () => {
      router.events?.off('routeChangeStart', handleStart);
      router.events?.off('routeChangeComplete', handleComplete);
      router.events?.off('routeChangeError', handleComplete);

      document.removeEventListener('click', handleGlobalClick, true);
    };
  }, []);

  return loading ? <PageLoader /> : <>{props.children}</>;
};

export default Loader;
